export function getBasename(filename: string): string {
    const filenameStartIndex = filename.lastIndexOf("/") + 1
    return filename.slice(filenameStartIndex)
}

export default getBasename;
